import { ArrowRight } from 'lucide-react';
import { Base, Fqdn, Text } from '@gandi/ui';
import { InteractiveBlock } from '../../../InteractiveBlock';
import { getLink } from './modules/links';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Item-root_1H4M2",
  "body": "Item-body_2EUKX"
};
export function Item({
  item,
  adminURL,
  sharingId,
  orderId
}) {
  return /*#__PURE__*/_jsx(InteractiveBlock, {
    tagName: "li",
    flex: true,
    to: getLink({
      adminURL,
      item,
      orderId,
      sharingId
    }),
    "aria-label": item.name_label,
    className: styles.root,
    children: /*#__PURE__*/_jsxs(Base, {
      color: "base",
      className: styles.body,
      children: [item.product_type === 'domains' ? /*#__PURE__*/_jsx(Fqdn, {
        children: item.name_label
      }) : /*#__PURE__*/_jsx(Text, {
        weight: "semibold",
        children: item.name_label
      }), /*#__PURE__*/_jsx("span", {
        className: styles.svg,
        children: /*#__PURE__*/_jsx(ArrowRight, {})
      })]
    })
  });
}